/**
 * MUI theme customization
 * Matches the original Dash app's Bootstrap Spacelab theme
 */

import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#00889a', // Teal - main brand color
      light: '#00a5ba',
      dark: '#006b7d',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#C76300', // Orange - for highlights (Geneva results)
      light: '#e07300',
      dark: '#a04d00',
      contrastText: '#ffffff',
    },
    background: {
      default: '#ffffff',
      paper: '#f5f5f5',
    },
    text: {
      primary: '#454348',
      secondary: '#575757',
    },
    error: {
      main: '#D32929',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
      color: '#454348',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      color: '#454348',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      color: '#454348',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      color: '#ffffff',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 400,
    },
    button: {
      textTransform: 'none', // Disable uppercase transform
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          padding: '8px 16px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#00889a',
          boxShadow: 'none',
        },
      },
    },
  },
});
